require("katex/dist/katex.min.css")
require("./static/prism-tomorrow-night.css")
require("./static/custom.css")
